import styled from 'styled-components';

type ContextMenuProps = {
    x?: number | null;
    y?: number | null;
};

export const ContextMenuStyle = styled.div<ContextMenuProps>`
    position: absolute;
    top: ${(props) => props.y ?? 0}px;
    left: ${(props) => props.x ?? 0}px;
    width: 300px;
    background: #fff;
    box-shadow: #eee 0 2px 6px 2px;
    border: 1px solid #ccc;
    padding: 6px;
    z-index: 10;
    cursor: pointer;
`;

type ContextMenuItemProps = {
    isDisabled: boolean;
};

export const ContextMenuItem = styled.div<ContextMenuItemProps>`
    text-align: left;
    font-size: 0.8rem;
    padding: 4px;
    border-bottom: 1px solid #ccc;
    &:hover {
        background: #eee;
    }
    ${(props) => props.isDisabled && `color: #888;font-style: italic;`}
`;

export const MenuItemSeparator = styled.hr`
    margin: 0;
    border: 0;
    border-top: 2px solid #ccc;
`;
